import { render, staticRenderFns } from "./SmooFooter.vue?vue&type=template&id=465bc286&"
import script from "./SmooFooter.ts?vue&type=script&lang=ts&"
export * from "./SmooFooter.ts?vue&type=script&lang=ts&"
import style0 from "./SmooFooter.vue?vue&type=style&index=0&id=465bc286&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports